import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { ROUTES } from '../../utils/constants';
import { LayoutDashboard } from 'lucide-react';

export const TeacherLandingPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-app-bg dark:bg-gray-950 text-app-text dark:text-gray-100">
      <header className="border-b border-app-border dark:border-gray-800 bg-app-surface dark:bg-gray-900/95 py-4">
        <div className="mx-auto max-w-6xl px-4 flex items-center justify-between">
          <Link to={ROUTES.LANDING} className="text-lg font-bold text-primary-600 dark:text-primary-400">
            TKM
          </Link>
          <Button variant="ghost" size="sm" onClick={() => navigate(ROUTES.LOGIN)}>
            Log in
          </Button>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-16">
        <LayoutDashboard className="h-16 w-16 text-primary-500 dark:text-primary-400" />
        <h1 className="mt-6 text-3xl font-bold text-app-text dark:text-white">Teacher Dashboard</h1>
        <p className="mt-2 text-app-text-muted dark:text-gray-400 max-w-xl">
          Class summary, exportable reports, and content curation. Monitor can-do achievement and vocabulary growth.
        </p>
        <div className="mt-10">
          <Button onClick={() => navigate(ROUTES.LANDING)}>Back to home</Button>
        </div>
      </main>
    </div>
  );
};
